import { useEffect } from 'react';

export default function usePrompt(when = true) {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (when) {
        event.preventDefault();
        event.returnValue = true;
      }
    };

    const handleTabChange = (event) => {
      if (when) {
        const confirmLeave = window.confirm('You have unsaved changes. Do you want to leave?');
        if (!confirmLeave) {
          event.preventDefault();
          event.returnValue = false;
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('tabchange', handleTabChange);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('tabchange', handleTabChange);
    };
  }, [when]);
}
